export default __webpack_public_path__ + "static/media/users.f60b40cb.svg";